export default __webpack_public_path__ + "static/media/sofa-3-seat-3-back.bc4155e9.webp";